import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Post-logout landing route (`/auth/logged-out`). The server-side auth-host cookie
 * session has already been terminated by end_session (D13b), and the in-memory token
 * family is gone with the redirect. Nothing to clean up here — send the user to the
 * interactive login page.
 */
export function LoggedOut() {
  useEffect(() => {
    // Reset the one-attempt-per-load silent marker so the next protected navigation
    // gets a fresh silent round if the user signs back in elsewhere.
    sessionStorage.removeItem('nexo.auth.silentAttempted');
  }, []);

  // After an explicit logout, show the tenant picker (not an auto-redirect back to the
  // ABP page) so the user can sign in as a different org/user.
  return <Navigate to="/login?pick=1" replace />;
}
